import backBtn from "../../assets/icons/back-btn.png";
import logo from "../../assets/doctio-logo.svg";
import fraseIkon from "../../assets/icons/Paper-icon + circle.svg";
import sygeplejerske from "../../assets/people/TBV03816.png";
import { SignUpStep1Props } from "../../types/Signup/SignUpStep";
import { Link } from "react-router-dom";
import Stats from "../Stats/Stats";

export default function SignUpStep1({
  navigate,
  nextStep,
  statsData,
  signUpData,
  setSignUpData,
}: SignUpStep1Props) {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSignUpData({
      ...signUpData,
      [event.target.name]: event.target.value,
    });
  };

  const isValidEmail = (email: string) => /\S+@\S+\.\S+/.test(email);
  const isFormValid =
    signUpData.name.trim() !== "" &&
    isValidEmail(signUpData.email) &&
    signUpData.password.length >= 6 &&
    signUpData.password === signUpData.password2;

  return (
    <div>
      <section className="md:h-screen">
        <div className="grid mx-auto h-full md:grid-cols-2">
          <div className="bg-white container mb-10 md:w-2/3 mx-auto md:py-6 order-2 md:order-1">
            <div className="header mt-2 hidden md:block flex items-center justify-between md:block">
              <button
                className="flex items-center md:mb-24"
                onClick={() => navigate(-1)}
              >
                <img src={backBtn} width={26} className="mr-3" alt="Tilbage" />
                <p className="text-doctio-green">Tilbage</p>
              </button>
              <img
                src={logo}
                width={150}
                className="md:mr-3 md:mb-20 w-[120px] md:w-[150px]"
                alt="Logo"
              />
            </div>

            <h1 className="text-d2xl font-bold leading-tight tracking-tight text-doctio-green md:text-d2xl">
              Opret bruger gratis
            </h1>

            <p>
              Opret dig på 2 minutter og få adgang til vores basis fraser og
              journalkoncepter. Ingen kreditkort.
            </p>

            <p className="mb-0">
              Allerede bruger?{" "}
              <a href="/login" className="text-doctio-green">
                Log ind
              </a>
            </p>

            <form
              className="space-y-4 mt-8 signup-form md:space-y-6"
              action="#"
            >
              <div>
                <input
                  type="text"
                  name="name"
                  id="navn"
                  placeholder="Navn"
                  value={signUpData.name}
                  onChange={handleInputChange}
                  className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-green-800 focus:border-green-800 block w-full p-6"
                  required={true}
                />
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  id="emailregister"
                  value={signUpData.email}
                  onChange={handleInputChange}
                  className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-green-800 focus:border-green-800 block w-full p-6"
                  placeholder="Email"
                  required={true}
                />
              </div>
              <div>
                <input
                  type="password"
                  name="password"
                  value={signUpData.password}
                  onChange={handleInputChange}
                  id="password"
                  placeholder="Password"
                  className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-green-800 focus:border-green-800 block w-full p-6"
                  required={true}
                />
              </div>
              <div>
                <input
                  type="password"
                  name="password2"
                  id="confirm-password"
                  value={signUpData.password2}
                  onChange={handleInputChange}
                  placeholder="Gentag password"
                  className="border mb-12 border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-green-800 focus:border-green-800 block w-full p-6"
                  required={true}
                />
              </div>

              <button
                type="button"
                onClick={() => nextStep()}
                style={{ opacity: isFormValid ? 1 : 0.6 }}
                disabled={!isFormValid}
                className="text-white transition-colors w-full duration-300 ease-in-out font-bold rounded-full bg-doctio-green hover:bg-white hover:text-doctio-green hover:shadow-md focus:ring-4 focus:outline-none px-4 py-4 text-center mr-3 md:mr-0"
              >
                Næste
              </button>
            </form>
          </div>
          <div className="relative container w-full mx-auto md:max-w-none md:bg-doctio-lightgreen md:py-40 md:h-screen order-1 md:order-2 overflow-hidden">
            <div className="shadow-right"></div>
            <div className="md:w-2/3 mx-auto">
              <div className="image-container relative">
                <div className="header mt-4 mb-4 md:hidden flex items-center justify-between md:block">
                  <Link to="/">
                    <img
                      src={logo}
                      width={150}
                      className="md:mr-3 md:mb-20 w-[120px] md:w-[150px]"
                      alt="Logo"
                    />
                  </Link>
                  <button
                    className="flex items-center md:mb-8"
                    onClick={() => navigate(-1)}
                  >
                    <img
                      src={backBtn}
                      width={26}
                      className="mr-3"
                      alt="Tilbage"
                    />
                    <p className="text-doctio-green">Tilbage</p>
                  </button>
                </div>
                <img
                  src={sygeplejerske}
                  className="mr-3 h-96 object-cover md:h-auto w-full md:object-fit mb-10 picture-shadow rounded-3xl"
                  alt="Sygeplejerske"
                />

                <div className="mt-12 mb-10 hidden md:block">
                  <p className="leading-tight tracking-tight">
                    <span className="font-bold">Navn Navnesen</span>, Titel lige
                    her, Hospitalsnavn.
                  </p>
                  <p className="mt-2 italic">Bruger af Doctio</p>
                </div>

                <div className="absolute frase-ikon-sign hidden md:block left-[-95px] top-[40%]">
                  <img
                    src={fraseIkon}
                    width={199}
                    className="mr-3"
                    alt="Fraseikon"
                  />
                </div>
              </div>
              <Stats data={statsData} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
